// import React, { createContext, useContext, useState, useEffect } from "react";
// import { gql, useQuery } from "@apollo/client";

// const GetMeContext = createContext();

// export const GET_ME = gql`
//   query me {
//     me {
//       id
//       name
//       email
//       phone
//       address
//       city
//       state
//       country
//     }
//   }
// `;

// export const GetMeProvider = ({ children }) => {
//   const [user, setUser] = useState(null);

//   const { data, loading, error } = useQuery(GET_ME);

//   useEffect(() => {
//     if (!loading && data) {
//       setUser(data);
//     }

//     if (error) {
//       console.error("No user Found:", error);
//       setUser(null);
//     }
//   }, [loading, data, error]);

//   return <GetMeContext.Provider value={user}>{children}</GetMeContext.Provider>;
// };

// export const useGetMe = () => {
//   return useContext(GetMeContext);
// };

import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import PropTypes from 'prop-types';
import { gql, useQuery } from "@apollo/client";

const GetMeContext = createContext();

export const GET_ME = gql`
  query me {
    me {
      id
      name
      email
      phone
      address
      city
      state
      country
      profile_pic
    }
  }
`;

export const GetMeProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const { data, loading, error, refetch } = useQuery(GET_ME);

  useEffect(() => {
    if (!loading && data) {
      setUser(data);
    }

    if (error) {
      console.error("No user Found:", error);
      setUser(null);
    }
  }, [loading, data, error]);

  const value = useMemo(() => ({ user, refetch }), [user, refetch]);

  return (
    <GetMeContext.Provider value={value}>
      {children}
    </GetMeContext.Provider>
  );
};

GetMeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useGetMe = () => {
  return useContext(GetMeContext);
};